export { default } from './content'

import "./__content.scss"; import "./__form.scss"; import "./content.scss"
